import { RemoveRedEye } from "@mui/icons-material";
import { Box, Card } from "@mui/material";
import {
  Button,
  email,
  PasswordInput,
  required,
  SimpleForm,
  TextInput,
  TopToolbar,
  useGetIdentity,
  Toolbar,
  SaveButton,
  useUpdate,
  useNotify,
  useRedirect,
  minLength,
} from "react-admin";
import { Link } from "react-router-dom";

import { MODULE_NAMES } from "@/constants";
import { UserGroupArrayInput } from "@/inputs/UserGroupArrayInput.tsx";
import { equalPasswords, formatObjectsToArrayOfIds } from "@/utils";

const MIN_PASSWORD_LENGTH = 5;

const PostEditToolbar = () => (
  <Toolbar>
    <SaveButton />
  </Toolbar>
);

export const SettingsEdit = () => {
  const { data: identity, isLoading } = useGetIdentity();
  const [update] = useUpdate();
  const notify = useNotify();
  const redirect = useRedirect();

  if (isLoading || !identity) return null;

  const handleSave = async (values: Record<string, unknown>): Promise<void> => {
    await update(
      MODULE_NAMES.USERS,
      {
        id: identity.id,
        data: values,
        previousData: identity,
      },
      {
        onSuccess: () => {
          notify("Профиль обновлён", { type: "success" });
          redirect("/settings");
        },
        onError: (err) => {
          notify(err.message, { type: "error" });
        },
      },
    );
  };

  return (
    <>
      <Box sx={{ flex: "0 1 auto" }}>
        <TopToolbar>
          <Button
            label="Show"
            startIcon={<RemoveRedEye />}
            component={Link}
            to="/settings"
          />
        </TopToolbar>
      </Box>
      <Card>
        <SimpleForm
          record={identity}
          onSubmit={handleSave}
          toolbar={<PostEditToolbar />}
        >
          <TextInput
            source="username"
            helperText="example: John"
            placeholder="Enter Name"
            validate={required()}
          />
          <TextInput
            type="email"
            source="email"
            validate={[required(), email()]}
            helperText="example: temp@domain.com"
            placeholder="Enter Email"
          />
          <UserGroupArrayInput
            source="groups"
            format={formatObjectsToArrayOfIds}
          />
          <PasswordInput
            source="plainPassword"
            validate={minLength(MIN_PASSWORD_LENGTH)}
          />
          <PasswordInput source="confirmPassword" validate={equalPasswords} />
        </SimpleForm>
      </Card>
    </>
  );
};
